import { AUTO_POST } from "./autoPostName";
import { autoPostActiveProjectsLabel, getAutoPostQueueText } from "./autoPostStatus";

/** Layout adapter for the shared status; it owns no date or count wording. */
export function autoPostQueueTooltip({ count, nextPostAt }: {
  count: number;
  nextPostAt?: Date | string | null;
}, now = new Date()): { label: string; html: string } | null {
  const text = getAutoPostQueueText({ upcoming: count, nextPostAt }, now);
  if (!text) return null;
  const detail = [text.nextPost, text.compactCountLabel].filter(Boolean).join(" · ");

  // Only fixed copy, a numeric count and formatted date enter this HTML.
  return {
    label: `${AUTO_POST}. ${text.summary}`,
    html: `<div class="flex flex-col gap-0.5"><span class="font-medium">${AUTO_POST}</span><span class="text-slate-400">${detail}</span></div>`,
  };
}

/** Activity is independent of the queue; a processing project is already on. */
export function autoPostOverviewTooltip({ activeProjectCount, count = 0, nextPostAt }: {
  activeProjectCount: number;
  count?: number;
  nextPostAt?: Date | string | null;
}, now = new Date()): { label: string; html: string } | null {
  if (!Number.isFinite(activeProjectCount) || activeProjectCount <= 0) return null;
  const activity = autoPostActiveProjectsLabel(activeProjectCount);
  const queue = getAutoPostQueueText({ upcoming: count, nextPostAt }, now);
  const detail = queue ? [queue.nextPost, queue.countLabel].filter(Boolean).join(" · ") : null;
  return {
    label: `${activity}${queue ? `. ${queue.summary}` : ""}`,
    html: `<div class="flex flex-col gap-0.5"><span class="font-medium">${AUTO_POST} <span class="font-normal tabular-nums text-slate-400">${activeProjectCount}</span></span>${detail ? `<span class="text-slate-400">${detail}</span>` : ""}</div>`,
  };
}
